import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "state"
}
const _hoisted_3 = {
  key: 1,
  class: "state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_DocContent = _resolveComponent("DocContent")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.goBack
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.arrowBackOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.doc ? _ctx.doc.title : 'Help'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading guide..."))
              : (!_ctx.doc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "This guide could not be loaded. Connect to the internet and try again."))
                : (_openBlock(), _createBlock(_component_DocContent, {
                    key: 2,
                    doc: _ctx.doc,
                    anchor: _ctx.anchor,
                    offline: _ctx.offline,
                    "updated-note": _ctx.updatedNote
                  }, null, 8, ["doc", "anchor", "offline", "updated-note"]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}